export default {
    path: '/reports/studentreportbylocationalternatives',
    component: () =>
      import('@/views/general-reports/teachers-for-students/Wrapper.vue'),
    children: [
      {
        path: '',
        name: 'teachers-for-students',
        component: () =>
          import('@/views/general-reports/teachers-for-students/Main.vue'),
      },
    ],
  }